export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于我们</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">了解吃瓜网站的故事与使命</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-fire-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">吃瓜，我们是认真的</h3>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                吃瓜网站诞生于网民对娱乐八卦和热点事件永不熄灭的好奇心。我们致力于打造中文互联网上最全面、最及时、最真实的吃瓜视频聚合平台，让每一位"吃瓜群众"都能在这里找到属于自己的那份快乐。
              </p>
              <p>
                从网红爆料到明星动态，从综艺名场面到社交媒体热议事件，我们的编辑团队7×24小时不间断追踪全网热点，精心筛选和整理每一条有价值的吃瓜内容。我们不仅提供最新最快的吃瓜视频，更注重内容的质量和真实性——每一条重要爆料都会经过多方核实，确保你看到的不是谣言，而是有据可查的事实。
              </p>
              <p>
                截至目前，吃瓜网站已积累超过15,000条吃瓜视频资源，月活跃用户突破500万。未来我们将持续优化内容质量和浏览体验，让吃瓜变得更简单、更有趣、更可靠。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}